module.exports = __webpack_public_path__ + "img/14a58c3.png";